
import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { Button } from 'primereact/button';  
import { Tag } from 'primereact/tag';     
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import { Skeleton } from 'primereact/skeleton';
import { Paginator } from 'primereact/paginator';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import { Dialog } from 'primereact/dialog';
import { editComment, getSpecificComments } from '../../api/axiosComments';
import { InputSwitch } from 'primereact/inputswitch';
import { Panel } from 'primereact/panel';
import { capitalizeFirstLetter } from '../../utilities/UtilityFunctions';
import { getNotifications } from '../../api/axiosNotifications';










const CommentSubmissions = ({ commentTitle }) => {
  
  const { setFetcherror, auntheticatedUser,
    notifications, setNotifications,
    isLoadingNotifications, setIsLoadingNotifications,
    fetcherrorNotifications, setFetcherrorNotifications
      
    } = useContext(DataContext);
 

    const toast = useRef(null);
    const [globalFilter, setGlobalFilter] = useState("");
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [viewDialogVisible, setViewDialogVisible] = useState(false);
    const [comments, setComments] = useState([]);
    const [ICNrowData, setICNrowData] = useState({});
    const [commentValid, setCommentValid] = useState(false);
   
  

  
  
  
  
  const user_id = auntheticatedUser?.id;
  const  user_name = `${capitalizeFirstLetter(auntheticatedUser?.firstname)}  ${capitalizeFirstLetter(auntheticatedUser?.firstname)}`
  
  const operatorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
  
  
    useEffect(() => {
  
      fetchIncidents();   
    }, []);
  
  
  
    const fetchIncidents = () => { 
        getSpecificComments(
            setComments,
            setFetcherror,
            setIsLoading,
            setFirst,
            setRows,
            undefined,
            setTotalCount,
            false,
            false,
        );
     
     
    }
  
    // const incidentTitle = <span className='p-5'>New Incident</span>;
    // const finalrolesArray = roles.map((role) => ({ ...role, name: (role?.name).substring(2) })).filter((item) => item?.name !== "Admin");
    
  
  
   
    
    const filteredPortalSubmissions = comments.length>0 ?  comments?.filter( (item) => item.content.toLowerCase().includes(globalFilter)) : []
    // const filteredReversedPortalSubmissions = filteredPortalSubmissions.reverse();
  
  
  
    const handleAllToasts = (statusNum, msg) => {
      AllToasts(statusNum, msg, toast);
    };
  
    const extractTime = (timestamp) => { 
      const stamp = new Date(timestamp);
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const dateTime = `${stamp.getDate()} ${months[stamp.getMonth()]} ${stamp.getFullYear()}  ${stamp.getHours()}:${stamp.getMinutes()}`;
      return dateTime;
    }
  
    const toProperCase = (textValue) => { 
      const newtextValue = (typeof(textValue==="string")) ? textValue[0].toUpperCase() + textValue.substring(1).toLowerCase() :"";
      return newtextValue;
    }
  
    const onPageChange = (event) => {
   
        getSpecificComments(
            setComments,
            setFetcherror,
            setIsLoading,
            setFirst,
            setRows,
            event,
            setTotalCount,
            false,
            false,
        );
     
  }
      
    
    const limitOptions = [5, 10, 20, 30, 50];
    const skeletonitems = Array.from({ length: 5 }, (v, i) => i);
    const maincardtitle = <div className='text-center'>{commentTitle }</div>;
    
    return (
  
      
      <div className="card">
        <Toast ref={toast} />
        
        <Card title={maincardtitle}>
        <SearchToolBar
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  searchPlaceholder="Incidents"
          
          />
          
          {!isLoading &&
            <DataTable
              value={filteredPortalSubmissions}
              showGridlines
              emptyMessage="No Comment Found"
              className=''
            >
              <Column className='w-5rem' header="S/N" body={(rowData) => comments?.indexOf(rowData) + 1} > </Column>
              <Column
                className='w-18rem'
                header="Victim Details"
                body={(rowData) => (
                  <div className='flex flex-column'>
                    <div className='text-color-secondary font-bold mb-2'>{rowData?.inc[0]?.incidentnumber}</div>
                    <div className='text-color-secondary text-sm font-bold'>Name:{rowData?.inc[0]?.firstnamevictim} {rowData?.lastnamevictim}</div>
                    <div className='text-color-secondary text-sm'>Phone:{rowData?.inc[0]?.phonevictim}</div>
                    <div className='text-color-secondary text-sm'>Sex:{rowData?.inc[0]?.sexvictim}</div>
                  </div>
  
                )} >
              
              </Column>
                      
              <Column
                className=''
                header="Updates"
                sortable
                body={(rowData) => (rowData.content)}>
              </Column>
            
              <Column
                className='w-12rem'
                header=" Status and Date"
                body={(rowData) => (
                  <div className='flex flex-column'>
                        <div className='mt-2 text-xs' ><span><Tag severity="danger" value="Pending"></Tag></span> </div>
                        <div className='text-color-secondary'>By:<span className='font-bold'>{toProperCase(rowData?.fromname)}</span></div>
                        <div className='mt-2 text-sm'>{extractTime(rowData?.createdAt)}</div>
                  </div>
                )}>
              </Column>
            
            
              <Column
                className='w-8rem'
                header="Actions"
                body={(rowData) => (
                  <Button
                      outlined
                      label="View"
                      icon="pi pi-eye"
                      className=" p-button-success px-3 py-1 text-xs mb-2 font-light"
                      onClick={() => {
                          
                        setViewDialogVisible(true);
                        setICNrowData(rowData);
                        
                       
                        
                  }}
                  />
                )}>
              </Column>
            </DataTable>
          }
          
          {isLoading && 
            
            <DataTable value={skeletonitems} className="p-datatable-striped">
            <Column field="S/N" header="S/N" style={{ width: '10%' }} body={<Skeleton />}sortable></Column>
            <Column field="Victim Details" header=" Victim Details" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
            <Column field="Updates" header="Updates" style={{ width: '50%' }} body={<Skeleton />}sortable></Column>
            <Column field="Status & Date" header="Status & Date" style={{ width: '15%' }} body={<Skeleton />}></Column>
            <Column field="Actions" header="Actions" style={{ width: '10%' }} body={<Skeleton />}></Column>
            </DataTable>
            }
  
            {!isLoading &&
              <Paginator
                first={first}
                rows={rows}
                totalRecords={totalCount}
                rowsPerPageOptions={limitOptions}
                onPageChange={onPageChange}
              />
            } 
          
          
  
          <Dialog visible={viewDialogVisible} modal headerClassName='mb-0 pb-0' style={{ width: '25rem' }} onHide={() => { setViewDialogVisible(false);setCommentValid(false) }}>
            <Panel header="Confirm Pending Comment">
            <div className='flex justify-content-center align-items-center w-full px-1 my-3'>
                <InputSwitch checked={commentValid} onChange={(e) => setCommentValid(e.value)} /> <span className='pl-3'>{commentValid ? <span className='text-success'>Accepted</span> :  <span className='text-danger'>Rejected</span>  }</span>
            </div>
            
              
              <div className='flex justify-content-end align-items-center mr-3'>

              <Button
              icon="pi pi-save"
              label="Save"
              outlined
              iconPos="left"
              className="ml-3 mt-2 py-2 px-3"
                  onClick={() => {
                
                
                    editComment(
                      ICNrowData?.id,
                      user_name,
                      user_id,
                      ICNrowData?.incident_id,
                      commentValid,
                      true,
                      setFetcherror,
                      handleAllToasts,
                      setComments,
                      setIsLoading,
                      setFirst,
                      setRows,
                      undefined,
                      setTotalCount,
                      setCommentValid,
                      setViewDialogVisible,
                      (err,data) => {
                        if (data) { 
                        setViewDialogVisible(false);
                        getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated? undefined: auntheticatedUser.id);
                        }
                       }
                      

                                
                    )
              
               }}
                      />
                
              </div>
            
            </Panel>
          </Dialog>
  
  
                  
        </Card>
  
     
      </div>
    )
  }

export default CommentSubmissions